import React from 'react';

// ─────────────────────────────────────────────
// Reusable Modal wrapper
// ─────────────────────────────────────────────
export const Modal = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{title}</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body">
          {children}
        </div>
        <div className="modal-footer">
          <button onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

// ─────────────────────────────────────────────
// Terms & Conditions Content
// ─────────────────────────────────────────────
export const TermsContent = () => (
  <div className="policy-content">
    <h2>1. Important Notice: Disclaimer, Release &amp; Limitation</h2>
    <div className="policy-sub-block">
      <h3>1.1 Limited Liability</h3>
      <p>Vikas Fund shall not be liable for any submission, application, idea, document, or related matter, except in cases of gross negligence or willful misconduct.</p>
    </div>
    <div className="policy-sub-block">
      <h3>1.2 No Confidentiality</h3>
      <p>Vikas Fund shall have no obligation to maintain confidentiality regarding any submission, information, document, or idea shared by the applicant. Applicants are advised not to submit sensitive personal or confidential business information.</p>
    </div>
    <div className="policy-sub-block">
      <h3>1.3 Similar Ideas</h3>
      <p>Vikas Fund may already be independently developing or evaluating ideas similar to those submitted by applicants. In such cases, the applicant shall have no right to claim ownership, compensation, or damages against Vikas Fund.</p>
    </div>
    <div className="policy-sub-block">
      <h3>1.4 Release of Claims</h3>
      <p>By submitting an application, the Applicant/Submitter permanently agrees to waive and release Vikas Fund, its promoters, directors, officers, employees, representatives, successors, and assigns from any claims, liabilities, damages, costs, or legal actions arising out of or related to the submission.</p>
    </div>

    <h2>2. Definitions</h2>
    <div className="policy-sub-block">
      <h3>2.1 Vikas Fund</h3>
      <p>"Vikas Fund" shall include its promoters, directors, officers, employees, representatives, successors, and assigns.</p>
    </div>
    <div className="policy-sub-block">
      <h3>2.2 Applicant/Submitter</h3>
      <p>The individual or entity submitting an idea, proposal, or application.</p>
    </div>
    <div className="policy-sub-block">
      <h3>2.3 Submission</h3>
      <p>Any form, document, attachment, video pitch, PDF, communication, or other material submitted by the applicant, which shall be treated as an electronic record admissible under the Indian Evidence Act, 1872.</p>
    </div>
    <div className="policy-sub-block">
      <h3>2.4 Form</h3>
      <p>The official submission form available on the Vikas Fund website.</p>
    </div>
    <div className="policy-sub-block">
      <h3>2.5 Website</h3>
      <p>www.vikasfund.com</p>
    </div>
    <div className="policy-sub-block">
      <h3>2.6 Intellectual Property Rights (IP Rights)</h3>
      <p>Patents, trademarks, copyrights, designs, trade secrets, database rights, moral rights, and all other intellectual property rights.</p>
    </div>

    <h2>3. Website Operations &amp; Administrative Structure</h2>
    <div className="policy-sub-block">
      <h3>3.1 Website Operations</h3>
      <p>The Vikas Fund website is operated and managed under Kalkathit Maji Khasdar S K Dige Memorial Foundetion.</p>
    </div>
    <div className="policy-sub-block">
      <h3>3.2 Independent Operations</h3>
      <p>Kalkathit Maji Khasdar S K Dige Memorial Foundetion may be used solely for payment collection, gateway processing, banking, compliance, or administrative purposes related to Vikas Fund. However, the Foundation shall not participate in or control the evaluation, selection, approval, rejection, funding decisions, operations, or management of Vikas Fund submissions or activities, which shall remain independently handled by the Vikas Fund team.</p>
    </div>
    <div className="policy-sub-block">
      <h3>3.3 No Claims Against Foundation</h3>
      <p>Applicants shall not raise any claim, liability, dispute, or legal action against Kalkathit Maji Khasdar S K Dige Memorial Foundetion in relation to Vikas Fund submissions, evaluations, funding decisions, or related matters.</p>
    </div>

    <h2>4. Submission Process &amp; Requirements</h2>
    <div className="policy-sub-block">
      <h3>4.1 Official Submission Process</h3>
      <p>All submissions shall only be made through the official online submission form available on the website. Clicking the "SUBMIT" button shall constitute acceptance of these Terms &amp; Conditions and Privacy Policy.</p>
    </div>
    <div className="policy-sub-block">
      <h3>4.2 Information Responsibility</h3>
      <p>Applicants shall submit only public, lawful, and self-owned information. The applicant shall remain solely responsible for the accuracy and legality of all submitted content.</p>
    </div>
    <div className="policy-sub-block">
      <h3>4.3 Mandatory Video Pitch</h3>
      <p>Applicants must submit a video pitch not exceeding three (3) minutes. Supported formats include MP4, MOV, and AVI.</p>
    </div>
    <div className="policy-sub-block">
      <h3>4.4 Mandatory PDF &amp; Supporting Proofs</h3>
      <p>Applicants must submit a PDF containing details of the idea, implementation plan, and estimated budget. Supporting proof such as declarations, notarized statements, patent copies, or other valid documents may also be required.</p>
    </div>
    <div className="policy-sub-block">
      <h3>4.5 Incomplete Submissions</h3>
      <p>Failure to provide the required video pitch, PDF documents, or supporting proofs shall render the submission incomplete or invalid. Incomplete applications shall not be considered for funding.</p>
    </div>
    <div className="policy-sub-block">
      <h3>4.6 Rejected Submissions</h3>
      <p>Rejected submissions may be notified via email; however, Vikas Fund shall not be obligated to disclose the reasons for rejection.</p>
    </div>

    <h2>5. Funding Decision, Evaluation &amp; Timeline Policy</h2>
    <div className="policy-sub-block">
      <h3>5.1 Sole Discretion</h3>
      <p>All submissions shall be evaluated solely based on Vikas Fund's internal criteria, policies, and discretion.</p>
    </div>
    <div className="policy-sub-block">
      <h3>5.2 No Funding Guarantee</h3>
      <p>Submission of an application or payment of the processing fee does not guarantee funding approval, applicant selection, project success, or any future support.</p>
    </div>
    <div className="policy-sub-block">
      <h3>5.3 Funding Amount Determination</h3>
      <p>The amount of funding, financial assistance, support, or grant, if any, shall be determined solely at the discretion of Vikas Fund based on internal evaluation, availability of resources, project requirements, verification, and other relevant factors. Applicants shall have no right to demand, request, negotiate, or insist upon any specific funding amount.</p>
    </div>
    <div className="policy-sub-block">
      <h3>5.4 Submission Window</h3>
      <p>Vikas Fund may announce specific submission opening and closing dates for applications. Applicants must submit their applications within the prescribed submission period.</p>
    </div>
    <div className="policy-sub-block">
      <h3>5.5 Estimated Evaluation Timeline</h3>
      <p>Application evaluation, review, verification, and result declaration timelines are tentative and may vary depending on the number of submissions, verification requirements, administrative processes, or other operational factors.</p>
    </div>
    <div className="policy-sub-block">
      <h3>5.6 No Fixed Result Guarantee</h3>
      <p>Vikas Fund does not guarantee that application results, approvals, or funding decisions will be declared within any fixed or specific time period.</p>
    </div>
    <div className="policy-sub-block">
      <h3>5.7 Delay Rights</h3>
      <p>Vikas Fund reserves the right to extend, postpone, delay, suspend, or modify the submission process, evaluation timeline, or result declaration process without prior notice.</p>
    </div>
    <div className="policy-sub-block">
      <h3>5.8 Funding Verification Process</h3>
      <p>Applicants may be informed regarding the final status of their application solely through official email communication. In case of provisional funding approval, Vikas Fund may notify the applicant regarding the proposed funding amount and may require additional supporting documents, proofs, declarations, quotations, utilization plans, bank details, or other verification documents related to the intended usage of the funds.</p>
    </div>
    <div className="policy-sub-block">
      <h3>5.9 Mandatory Proof Submission Timeline</h3>
      <p>Applicants shall submit all required verification documents within forty-eight (48) hours from the official communication. Failure to provide the required documents within the prescribed timeline may result in cancellation, suspension, withdrawal, or rejection of the proposed funding at the sole discretion of Vikas Fund.</p>
    </div>

    <h2>6. Intellectual Property Rights</h2>
    <div className="policy-sub-block">
      <h3>6.1 Rights Retention</h3>
      <p>All ownership rights in the submitted idea shall remain with the applicant.</p>
    </div>
    <div className="policy-sub-block">
      <h3>6.2 Limited License</h3>
      <p>The applicant grants Vikas Fund a non-exclusive, royalty-free, worldwide license for a period of five (5) years solely for evaluation and review purposes.</p>
    </div>
    <div className="policy-sub-block">
      <h3>6.3 Originality Responsibility</h3>
      <p>The applicant shall be solely responsible for ensuring that the submitted idea, content, and materials are original and lawful.</p>
    </div>
    <div className="policy-sub-block">
      <h3>6.4 Indemnity</h3>
      <p>The applicant agrees to indemnify and hold Vikas Fund harmless against any third-party claims, damages, liabilities, costs, or legal expenses arising from the submission.</p>
    </div>
    <div className="policy-sub-block">
      <h3>6.5 No Compensation</h3>
      <p>Submission of an idea shall not entitle the applicant to any compensation, royalty, recognition, or credit from Vikas Fund.</p>
    </div>
    <div className="policy-sub-block">
      <h3>6.6 No Usage Obligation</h3>
      <p>Vikas Fund shall have no obligation to use, implement, promote, or develop any submitted idea.</p>
    </div>
    <div className="policy-sub-block">
      <h3>6.7 Brand Usage Restriction</h3>
      <p>Applicants shall not use the Vikas Fund name, logo, branding, or intellectual property without prior written permission.</p>
    </div>

    <h2>7. Processing Fee Policy</h2>
    <div className="policy-sub-block">
      <h3>7.1 Mandatory Processing Fee</h3>
      <p>A mandatory processing and evaluation fee of ₹700/- shall apply to each submission.</p>
    </div>
    <div className="policy-sub-block">
      <h3>7.2 Non-Refundable Fee</h3>
      <p>The processing fee shall remain strictly non-refundable under all circumstances, including incomplete, duplicate, rejected, or unsuccessful applications.</p>
    </div>
    <div className="policy-sub-block">
      <h3>7.3 Purpose of Fee</h3>
      <p>The processing fee is charged solely for application processing and evaluation purposes and does not guarantee funding approval.</p>
    </div>

    <h2>8. Communication Policy</h2>
    <div className="policy-sub-block">
      <h3>8.1 Official Communication</h3>
      <p>Official communication with Vikas Fund shall only be conducted through the official email channels.</p>
    </div>
    <div className="policy-sub-block">
      <h3>8.2 Response Timeline</h3>
      <p>Queries or complaints received through official email may be addressed within 48 hours.</p>
    </div>
    <div className="policy-sub-block">
      <h3>8.3 Invalid Communication</h3>
      <p>Communication made through unofficial channels or third-party mediums shall not be considered valid.</p>
    </div>

    <h2>9. Age Eligibility &amp; Parental Consent</h2>
    <div className="policy-sub-block">
      <h3>9.1 Minimum Age Requirement</h3>
      <p>Applicants must be at least eighteen (18) years of age.</p>
    </div>
    <div className="policy-sub-block">
      <h3>9.2 Minor Applicants</h3>
      <p>Applicants below 18 years of age must submit written parental/guardian consent along with a co-signed funding agreement.</p>
    </div>
    <div className="policy-sub-block">
      <h3>9.3 Invalid Application</h3>
      <p>Applications submitted without the required parental consent shall be considered invalid.</p>
    </div>
    <div className="policy-sub-block">
      <h3>9.4 Binding Consent</h3>
      <p>Parental or guardian consent submitted in relation to a minor applicant shall be binding and final.</p>
    </div>

    <h2>10. Duplicate Submission Policy</h2>
    <div className="policy-sub-block">
      <h3>10.1 Same Applicant Multiple Submissions</h3>
      <p>If the same idea is submitted multiple times by the same applicant, only the first submission may be considered valid.</p>
    </div>
    <div className="policy-sub-block">
      <h3>10.2 Similar Ideas by Different Applicants</h3>
      <p>Where substantially similar ideas are submitted by different persons, the final determination regarding validity or consideration shall rest solely with Vikas Fund.</p>
    </div>
    <div className="policy-sub-block">
      <h3>10.3 Duplicate Submission Fees</h3>
      <p>Processing fees paid for duplicate submissions shall not be refunded.</p>
    </div>

    <h2>11. Governing Law &amp; Dispute Resolution</h2>
    <div className="policy-sub-block">
      <h3>11.1 Governing Law</h3>
      <p>These Terms &amp; Conditions shall be governed and interpreted in accordance with the laws of India.</p>
    </div>
    <div className="policy-sub-block">
      <h3>11.2 Arbitration</h3>
      <p>Any dispute arising out of or relating to these Terms shall first be resolved through arbitration under the Arbitration &amp; Conciliation Act, 1996.</p>
    </div>
    <div className="policy-sub-block">
      <h3>11.3 Arbitration Details</h3>
      <p>The place of arbitration shall be Kolhapur, Maharashtra, India, and the proceedings shall be conducted in English and/or Marathi.</p>
    </div>
    <div className="policy-sub-block">
      <h3>11.4 Jurisdiction</h3>
      <p>Subject to arbitration, the courts located in Kolhapur shall have exclusive jurisdiction over all disputes.</p>
    </div>

    <h2>12. Force Majeure</h2>
    <div className="policy-sub-block">
      <h3>12.1 Unforeseen Circumstances</h3>
      <p>Vikas Fund shall not be held liable for delays, interruptions, or failures caused by natural disasters, pandemics, wars, government restrictions, technical failures, or other events beyond reasonable control.</p>
    </div>

    <h2>13. Severability</h2>
    <div className="policy-sub-block">
      <h3>13.1 Validity of Remaining Provisions</h3>
      <p>If any provision of these Terms &amp; Conditions is held invalid or unenforceable by a competent authority, the remaining provisions shall continue to remain valid and enforceable.</p>
    </div>

    <h2>14. Entire Agreement &amp; Amendments</h2>
    <div className="policy-sub-block">
      <h3>14.1 Complete Agreement</h3>
      <p>These Terms &amp; Conditions together with the official submission form shall constitute the complete and entire agreement between the applicant and Vikas Fund.</p>
    </div>
    <div className="policy-sub-block">
      <h3>14.2 Amendments</h3>
      <p>Vikas Fund reserves the sole right to modify, amend, update, or revise these Terms &amp; Conditions at any time, and such amendments shall become binding once published or made effective.</p>
    </div>
    <div className="policy-sub-block">
      <h3>14.3 Binding Acceptance</h3>
      <p>Submission of an application shall constitute confirmation that the applicant has read, understood, and accepted all Terms &amp; Conditions.</p>
    </div>
    <div className="policy-sub-block">
      <h3>14.4 No Other Promises</h3>
      <p>No oral statements, representations, or promises other than those expressly mentioned herein shall be legally valid or binding.</p>
    </div>
  </div>
);

// ─────────────────────────────────────────────
// Privacy Policy Content
// ─────────────────────────────────────────────
export const PrivacyContent = () => (
  <div className="policy-content">
    <h2>1. Information We Collect</h2>
    <div className="policy-sub-block">
      <h3>1.1 Personal Information</h3>
      <p>We collect personal information including but not limited to: name, email address, phone number, address, occupation, and business details when you submit an application.</p>
    </div>
    <div className="policy-sub-block">
      <h3>1.2 Business Information</h3>
      <p>We collect business ideas, plans, budgets, implementation strategies, and related documents submitted through our application process.</p>
    </div>
    <div className="policy-sub-block">
      <h3>1.3 Technical Information</h3>
      <p>We automatically collect certain technical information including IP address, browser type, device information, and usage patterns when you visit our website.</p>
    </div>
    <div className="policy-sub-block">
      <h3>1.4 Website Operations &amp; Administrative Support</h3>
      <p>The Vikas Fund website may operate under or receive administrative, banking, payment processing, compliance, technical, or operational support associated with Kalkathit Maji Khasdar S K Dige Memorial Foundetion.</p>
    </div>

    <h2>2. How We Use Your Information</h2>
    <div className="policy-sub-block">
      <h3>2.1 Application Processing</h3>
      <p>We use your information to process, evaluate, and make decisions regarding your funding application.</p>
    </div>
    <div className="policy-sub-block">
      <h3>2.2 Communication</h3>
      <p>We use your contact information to communicate with you about your application status, provide updates, and respond to your queries.</p>
    </div>
    <div className="policy-sub-block">
      <h3>2.3 Service Improvement</h3>
      <p>We analyze usage patterns and feedback to improve our services, website functionality, and user experience.</p>
    </div>
    <div className="policy-sub-block">
      <h3>2.4 Legal Compliance</h3>
      <p>We may use your information to comply with legal obligations, resolve disputes, and enforce our Terms &amp; Conditions.</p>
    </div>
    <div className="policy-sub-block">
      <h3>2.5 Verification &amp; Supporting Documents</h3>
      <p>Documents, video pitches, declarations, quotations, utilization plans, identity proofs, bank details, and other materials submitted by applicants may be reviewed, verified, processed, stored, or retained for evaluation, legal, compliance, fraud prevention, administrative, or operational purposes.</p>
    </div>

    <h2>3. Information Sharing and Disclosure</h2>
    <div className="policy-sub-block">
      <h3>3.1 No Sale of Information</h3>
      <p>We do not sell, trade, or rent your personal information to third parties for marketing purposes.</p>
    </div>
    <div className="policy-sub-block">
      <h3>3.2 Service Providers</h3>
      <p>We may share your information with trusted third-party service providers who assist us in operating our website, processing applications, payment processing, or conducting business operations.</p>
    </div>
    <div className="policy-sub-block">
      <h3>3.3 Legal Requirements</h3>
      <p>We may disclose your information if required by law, court order, government authority, or to protect our rights and the rights of others.</p>
    </div>
    <div className="policy-sub-block">
      <h3>3.4 Business Transfers</h3>
      <p>In the event of a merger, acquisition, restructuring, or transfer of operations, your information may be transferred as part of the business process.</p>
    </div>

    <h2>4. Payment Processing &amp; Financial Information</h2>
    <div className="policy-sub-block">
      <h3>4.1 Payment Processing</h3>
      <p>Payments made through the website may be processed through third-party payment gateways, banking partners, or authorized service providers.</p>
    </div>
    <div className="policy-sub-block">
      <h3>4.2 Financial Data Protection</h3>
      <p>Vikas Fund does not store complete debit card, credit card, UPI PIN, passwords, or sensitive banking credentials on its servers unless required by law.</p>
    </div>

    <h2>5. Data Security</h2>
    <div className="policy-sub-block">
      <h3>5.1 Security Measures</h3>
      <p>We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.</p>
    </div>
    <div className="policy-sub-block">
      <h3>5.2 Data Encryption</h3>
      <p>We use industry-standard encryption protocols to secure data transmission and storage.</p>
    </div>
    <div className="policy-sub-block">
      <h3>5.3 Access Controls</h3>
      <p>Access to personal information is restricted to authorized personnel only.</p>
    </div>
    <div className="policy-sub-block">
      <h3>5.4 No Absolute Security Guarantee</h3>
      <p>While we implement reasonable security measures, no method of electronic transmission, storage, or internet communication can be guaranteed to be completely secure. Users submit information at their own risk.</p>
    </div>

    <h2>6. Data Retention</h2>
    <div className="policy-sub-block">
      <h3>6.1 Retention Period</h3>
      <p>We retain personal information for as long as necessary to fulfill the purposes outlined in this Privacy Policy or as required by law.</p>
    </div>
    <div className="policy-sub-block">
      <h3>6.2 Application Data</h3>
      <p>Application data may be retained for up to five (5) years from the date of submission for evaluation, legal, compliance, administrative, or record-keeping purposes.</p>
    </div>
    <div className="policy-sub-block">
      <h3>6.3 Deletion Requests</h3>
      <p>Users may request deletion of personal information, subject to legal, compliance, operational, or record-retention requirements.</p>
    </div>

    <h2>7. Your Rights</h2>
    <div className="policy-sub-block">
      <h3>7.1 Access Rights</h3>
      <p>You may request access to the personal information we hold about you.</p>
    </div>
    <div className="policy-sub-block">
      <h3>7.2 Correction Rights</h3>
      <p>You may request correction of inaccurate or incomplete personal information.</p>
    </div>
    <div className="policy-sub-block">
      <h3>7.3 Deletion Rights</h3>
      <p>You may request deletion of your personal information subject to applicable legal exceptions.</p>
    </div>
    <div className="policy-sub-block">
      <h3>7.4 Data Portability</h3>
      <p>You may request a copy of your personal information in a structured format where technically feasible.</p>
    </div>

    <h2>8. Cookies and Tracking Technologies</h2>
    <div className="policy-sub-block">
      <h3>8.1 Cookie Usage</h3>
      <p>We use cookies and similar tracking technologies to enhance your browsing experience, analyze website traffic, improve functionality, and personalize content.</p>
    </div>
    <div className="policy-sub-block">
      <h3>8.2 Cookie Types</h3>
      <p>We may use session cookies, persistent cookies, analytics cookies, and similar technologies for authentication, preferences, security, and analytics purposes.</p>
    </div>
    <div className="policy-sub-block">
      <h3>8.3 Cookie Management</h3>
      <p>Users may control or disable cookies through browser settings; however, disabling cookies may affect certain website functionalities.</p>
    </div>

    <h2>9. Third-Party Links &amp; External Services</h2>
    <div className="policy-sub-block">
      <h3>9.1 External Websites</h3>
      <p>Our website may contain links to third-party websites, payment gateways, or external services. We are not responsible for the privacy practices, security, or content of such third-party platforms.</p>
    </div>
    <div className="policy-sub-block">
      <h3>9.2 Link Disclaimer</h3>
      <p>Users are encouraged to review the privacy policies and terms of any third-party websites or services accessed through our platform.</p>
    </div>

    <h2>10. International Data Transfers</h2>
    <div className="policy-sub-block">
      <h3>10.1 Cross-Border Transfers</h3>
      <p>Your information may be transferred to, stored, or processed in countries other than your country of residence depending on technical or operational requirements.</p>
    </div>
    <div className="policy-sub-block">
      <h3>10.2 Transfer Safeguards</h3>
      <p>Reasonable safeguards may be implemented to protect information during international data transfers.</p>
    </div>

    <h2>11. Children's Privacy</h2>
    <div className="policy-sub-block">
      <h3>11.1 Age Restrictions</h3>
      <p>Our services are not intended for individuals below eighteen (18) years of age without parental or guardian consent.</p>
    </div>
    <div className="policy-sub-block">
      <h3>11.2 Parental Consent</h3>
      <p>If we become aware that personal information of a minor has been submitted without valid parental or guardian consent, we may delete or restrict such information.</p>
    </div>

    <h2>12. Changes to Privacy Policy</h2>
    <div className="policy-sub-block">
      <h3>12.1 Policy Updates</h3>
      <p>Vikas Fund reserves the right to modify, amend, update, or revise this Privacy Policy at any time. Updated versions may be published on the website.</p>
    </div>
    <div className="policy-sub-block">
      <h3>12.2 Continued Use</h3>
      <p>Continued use of the website or services after changes to this Privacy Policy shall constitute acceptance of the updated policy.</p>
    </div>

    <h2>13. Contact Information</h2>
    <div className="policy-sub-block">
      <h3>13.1 Privacy Inquiries</h3>
      <p>For privacy-related questions, legal communication, compliance matters, or data-related requests, users may contact Vikas Fund through the official email address and correspondence address provided below.</p>
    </div>
    <div className="policy-sub-block">
      <h3>13.2 Official Contact &amp; Correspondence Address</h3>
      <p>Physical visits shall be strictly by prior appointment only.</p>
    </div>
    <div className="policy-sub-block">
      <p><strong>13.3 Kalkathit Maji Khasdar S K Dige Memorial Foundetion</strong> </p>
    <p><strong>Address:</strong> 1298 C Ward, Laxmipuri, Kolhapur, Maharashtra, India – 416002</p>
    <p><strong>Email:</strong> info@vikasfund.com</p>
    </div>
    <div className="policy-sub-block">
      <h3>13.4 Response Timeline</h3>
      <p>We aim to respond to privacy-related inquiries within 48 hours; however, response timelines may vary depending on the nature of the request.</p>
    </div>
  </div>
);

// ─────────────────────────────────────────────
// Ready-to-use Terms modal (used in HeroSection)
// ─────────────────────────────────────────────
export const TermsModal = ({ isOpen, onClose }) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title="Vikasfund: Terms & Conditions (English Version)"
  >
    <TermsContent />
  </Modal>
);

// ─────────────────────────────────────────────
// Ready-to-use Privacy modal (used in HeroSection)
// ─────────────────────────────────────────────
export const PrivacyModal = ({ isOpen, onClose }) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title="Vikasfund: Privacy Policy"
  >
    <PrivacyContent />
  </Modal>
);